// extracted by mini-css-extract-plugin
module.exports = {"footerEmail":"styles_footerEmail__tC3m5"};